import FetchStatusRepository    from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import ErrorRepository          from "../../../../domain/fundamentals/message/error/ErrorRepository";
import NotifyRepository         from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import RecordTemplate           from "../../../../domain/record/template/RecordTemplate";
import RecordTemplateRepository from "../../../../domain/record/template/RecordTemplateRepository";
import FetchStatusDataSource    from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import ErrorDataSource          from "../../../../infrastructure/datasource/error/ErrorDataSource";
import NotifyDataSource         from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import RecordTemplateDataSource from "../../../../infrastructure/datasource/record/template/RecordTemplateDataSource";
import RouterDispatcher         from "../../../../infrastructure/redux/router/RouterDispatcher";

class SaveRecordTemplate {
  constructor(
    private readonly dispatch,
    private readonly repository: RecordTemplateRepository = new RecordTemplateDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly errorRepository: ErrorRepository = new ErrorDataSource(dispatch),
    private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(dispatch),
  ) {
  }

  public async execute(template: RecordTemplate) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.save(template);
      this.notifyRepository.saveSuccess();
      this.routerDispatcher.recordTemplates();
    } catch (e) {
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default SaveRecordTemplate;
